import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { DomSanitizer } from "@angular/platform-browser";
import { Observable, catchError, EMPTY } from "rxjs";
import { NotificationComponent } from "../components/notification/notification.component";
import { OAuthConfig } from "../../environments/environment";
import { Router } from "@angular/router";
import { HANDLE_HTTP_ERRORS_LOCALLY } from './http-error-context';


@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
    constructor(private snackbar: MatSnackBar, private sanitizer: DomSanitizer, private router: Router) {

    }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.context.get(HANDLE_HTTP_ERRORS_LOCALLY)) return next.handle(request);
    if (OAuthConfig.issuer && request.url.startsWith(OAuthConfig.issuer)) {
      return next.handle(request);
    }
    return next.handle(request).pipe(catchError((err: HttpErrorResponse) => {
        if (request.url.includes("/user/current") && [401, 404].includes(err.status)) {
          return EMPTY;
        }
        // if (request.url.includes("/user/current") && err.status == 404) {
        //   this.router.navigate(["/unauthorized"]);
        // }
        console.log("Here in the niterceptor");
        const ignoredConc = "The database operation was expected to affect 1 row(s), but actually affected 0 row(s)";
        if (err.error.toString().includes(ignoredConc) || (err.error?.message?.toString() ?? '').includes(ignoredConc)) {
          return EMPTY;
        }
        if (err.error instanceof Error) {
          // A client-side or network error occurred. Handle it accordingly.
          this.showError(err.error.message, err.error?.toString(), err.url)
        } else {
            this.showError(""+err.status, (typeof err.error === 'string' ? err.error + "<br />" : "") + err.message, err.url)
        }
        console.log("Http error interceptor", err);

        // ...optionally return a default fallback value so app can continue (pick one)
        // which could be a default value (which has to be a HttpResponse here)
        // return Observable.of(new HttpResponse({body: [{name: "Default value..."}]}));
        // or simply an empty observable
        return EMPTY;
      }));
  }

  showError(message: string, description: string, url: string | null) {
    console.log("heeeeere", message, description, url)
    let errorSummary = `If the error persists, please contact the <b>ITS Help Desk</b> with the following information:<br /><br />`
        + `<b>HTTP Error message:</b><br />${message}<br /><br />`
        + `<b>Description:</b><br />${description}<br /><br />`
        + `<b>Request URL:</b><br />${url}<br /><br />`;
    const matches = description.match(/ClientConnectionId:([a-f0-9-]+)/);
    if (matches)
      errorSummary += `<b>Logs.Exception (ClientConnectionId):</b><br /><span style='background-color: yellow !important;'>${matches[1]}</span>`;
    const errorSummaryTrusted = this.sanitizer.bypassSecurityTrustHtml(errorSummary);
    this.Error(
      "Error",
      "An error occurred. Please try again. If the problem persists, please report it.",
      <string><unknown>null,
      <any>errorSummaryTrusted //error.error ? `${error.message}\n${error.error}` : error.message);
    );
  }

  Error(title: string, description: string, dismissLabel: string, details: string) {
        return this.snackbar.openFromComponent(NotificationComponent, {
          data: { title, description, dismissLabel, details, icon: "assets/images/warning.png" },
          verticalPosition: 'bottom',
          horizontalPosition: 'center',
          panelClass: ['custom-snackbar'],
        });
  }
}
